import React from 'react';
import Toast from 'react-bootstrap/Toast';
import NavigationHeader from '../components/navigationHeader';
import BreadCrumb from '../components/breadCrumb';
import Tab from 'react-bootstrap/Tab';
import BasicPortlet from '../components/basicPortlet';
import QualdoDataTable from '../components/bootstrapTable';
import URLWidget from './components/urlWidget';
import DomainMappingView from './business/views/DomainMappingView';
import KpiCatalogView from './business/views/KpiCatalogView';
import { hydrateConfigureCatalogueFromApi } from './business/utils/persistence';
import { getApi, postUIlogs, prepare_model_ab_data_for_a_config, get_api_call_cnt, get_api_call_complete_cnt, post_api_call_cnt, post_api_call_complete_cnt } from "../utils/event_handling";
import Nav from 'react-bootstrap/Nav';
import { CopyRightsFooter } from '../components/copyrights';
import MLModelEnvironment from './mlmodel/environment';
import AddModel from './mlmodel/addModel';
import DSEnvironment from './dataSources/dsEnvironment';
import AddDataSources from './dataSources/addDataSources';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { formModelVersionMap, getFeatureAccess, toastObj , checkPermissions} from "../utils/common_utils";
import Load from '../components/loadAction';
import ErrorHandler from '../components/error_500';
import RefreshesTable from "../components/refreshesTable";
import ConfigureDataRefreshTable from "./components/configureDataRefreshTable";
import { connect } from "react-redux";
import { addMLModelMapping, setMLModel, setModelABDataToList } from "../redux/actions";

import ConfigureABTest from "./mlmodel/configureABTest";
import { ModelABEdit } from "./mlmodel/modelABEdit";
import DataRefreshIntervalPortlet from './components/DataRefreshIntervalPortlet';
import {
    AB_MODELS_TABLE_TITLE, IS_NONE_CHECK, 
    // IS_NONE_SAAS_EDITION,
    MAX_SLEEP_TIME, MAX_SLEEP_ERROR, NEG_SLEEP_ERROR,
    MIN_SLEEP_TIME, MIN_SLEEP_ERROR
    // DQ_MONITOR_SECTIONS
} from "../utils/constant";
import { postMixpanel } from '../mixpanel';
import PipelineEnvironment from './pipeline/pipelineEnvironment';
import AddPipeline from './pipeline/addPipeline';
import store from "../redux/store";
import Form from 'react-bootstrap/Form';
import RcTooltip from 'rc-tooltip';
import Button from "react-bootstrap/Button";
import {
    // preFetchRelationshipData,
    preFetchMetaData,
    preFetchUserNotifications, prefetchDatasetDetails, prefetchRecencyDetails, prefetchRecentHistory,
    // prefetchModelABData,
    prefetchDataSize, preFetchMetadataDetails
} from "../utils/dataFetch";

import {
    // preFetchMonitorPreview,
    // preFetchMonitorInfo,
    // preFetchMonitorModelInfo,
    // preFetchModelDetails,
    // preFetchMonitorListViewData,
    preFetchMetrics,
    // preFetchFollowAttributes,
    // fromMonitorData,
    getLastProfilingTime
} from "../utils/monitorDataFetch";
import {
    setDataSource,
    setMlDataSource,
    addRelationship,
    addMetaData,
    addDataSource,
    addInfo,
    addLastProfilingTime,
    setEndDate,
    setStartDate,
    addDiscoveryStatus,
    addProcessingStatus,
    addEnvironment,
    addEnvironmentDataSourceMapping,
    addDataSourceDataSetMapping,
    addDataSetAttributeMapping,
    setAttribute,
    setDataSet,
    addMonitorPreview,
    addPerformancePreview,
    addCompletenessDataSetInfo,
    addCompletenessAttributeInfo,
    addTimelinessDataSetInfo,
    addTimelinessAttributeInfo,
    addConformityDataSetInfo,
    addConformityAttributeInfo,
    addAccuracyDataSetInfo,
    addAccuracyAttributeInfo,
    addDriftDataSetInfo,
    addDriftAttributeInfo,
    addConsistencyDataSetInfo,
    addConsistencyAttributeInfo,
    addMLDataSetInfo,
    addMLAttributeInfo,
    addMLModel,
    addModelPerformance,
    addModelDetails,
    // addFollowAttributes,
    addMonitorDQListViewData,
    addMetrics,
    addUserNotificationToState,
    addDatasetVersions,
    addUniquenessDataSetInfo,
    addUniquenessAttributeInfo,
    addRecencyDetails,
    addRecentHistory,
    addDataSize,
    addRecencyPreview,
    prefetchMonitorState,
    noIntegration,
    storeMetadataDetails,
    mappedDatasetInfo,
    listViewTableData
} from "../redux/actions";
import NoErrorInPreview from "../monitor/components/noErrorPreview";
import {logoutPageRedirect} from "../utils/common_utils";
import { getAllDataSources } from '../utils/configureEventHandling';
import { ChevronDown, TriangleAlert, X } from 'lucide-react';
import { testIntegration,testDataSource, editDataSource } from '../utils/configureEventHandling';
import {
    getDatasourceIcon
} from "../utils/configure_utils";
// import {
//     extractDatasetInfoForMonitorListView,
//     getMonitorTabDQPListViewTableData,
//     setDQShowMoreData
// } from "../utils/common_utils";

// let cur_data = null;
// let cur_datasource_updates=null;
// let cur_isAddDS = false;
// let pre_load = true;

class Configure extends React.Component {
    constructor(props) {
        super(props);
        let tab = "ds"
        if (this.props.route.navKey !== undefined && this.props.route.navKey !== null) {
            tab = this.props.route.navKey
        }
        const navigationState = (this.props.location && this.props.location.state) || {};
        if (navigationState.configureTab === "business") {
            tab = "business";
        }
        this.pre_load = true;
        this.formDataOnce = 1;
        this.getApi = getApi.bind(this);
        this.setAddModel = this.setAddModel.bind(this);
        this.setModelVersion = this.setModelVersion.bind(this);
        this.setAddDS = this.setAddDS.bind(this);
        this.testConnectionDataSource = this.testConnectionDataSource.bind(this);
        this.testConnectionIntegration = this.testConnectionIntegration.bind(this);
        this.viewAction = this.viewAction.bind(this);

        this.showToast = this.showToast.bind(this);
        this.closeToast = this.closeToast.bind(this);
        this.handleTab = this.handleTab.bind(this);
        this.setDataLimit = this.setDataLimit.bind(this);
        this.updateTable = this.updateTable.bind(this);
        this.getExistingABData = this.getExistingABData.bind(this);
        this.handleModelABAddition = this.handleModelABAddition.bind(this);
        this.modelHasModelABConfiguration = this.modelHasModelABConfiguration.bind(this);
        this.handleModelABDelete = this.handleModelABDelete.bind(this);
        this.showModelABConfigureSection = this.showModelABConfigureSection.bind(this);
        this.postUIlogs = postUIlogs.bind(this);
        this.updateEnvironmentList = this.updateEnvironmentList.bind(this);
        this.setEnvData = this.setEnvData.bind(this)
        this.handleIntegrationSaved = this.handleIntegrationSaved.bind(this)
        this.onIntegrationDeleted = this.onIntegrationDeleted.bind(this)
        this.onDatasourceDeleted = this.onDatasourceDeleted.bind(this)
        this.renderRefreshTable = this.renderRefreshTable.bind(this)
        // this.preFetchMonitorGraph = this.preFetchMonitorGraph.bind(this);

        this.sleepIntervalChanged = this.sleepIntervalChanged.bind(this);
        this.cancelSleepInterval = this.cancelSleepInterval.bind(this);
        this.submitSleepInterval = this.submitSleepInterval.bind(this);
        this.renderScanIntervalComponents = this.renderScanIntervalComponents.bind(this);
        this.renderScanIntervalContent = this.renderScanIntervalContent.bind(this);
        this.preFetch = this.preFetch.bind(this)

        // State variable => model_ab_data contains data for table rendering,
        // State variable => currModelABList contains AB data that is fetched from API
        this.state = {
            viewAction: false,
            errorOccurred: false,
            toastStatus: false,
            current_tab: tab,
            featureAccess: getFeatureAccess(),
            data: null,
            integration_details: null,
            integration_option: null,
            mlDetails: null,
            mlData: null,
            mlLimitExceed: null,
            dataLimitExceed: null,
            isAddModel: false,
            isModelVersion: false,
            isAddDS: false,
            planName: null,
            environment: null,
            datasets: [],
            attributes: [],
            maxModel: null,
            datasource_updates: null,
            dataRefreshesInfo: [],
            dataRefreshesInfoLoading: false,
            model_ab_data: null,
            currModelABList: [],
            model_ab_updated: false,
            model_updates: null,
            show: false,
            change_request_exists: false,
            env_id: null,
            datasourceErrorRefreshesId: "datasourceErrorRefreshes",
            modelRefreshesId: "modelRefreshes",
            intervalId: '',
            sleepComponentLoad: true,
            sleepInterval: 1,
            prevSleepInterval: 1,
            sleepIntervalClass: "d-none",
            isSleepIntervalErrMsg: "",
            updateStatus:false,
            pipelinesourcesRefreshesId:"pipelinesourceRefreshes",
            pipelinedata:null,
            pipelinesource_updates: null,
            allDataSourcesData: null,
            allDataSourcesList: [],
            configureProgressCollpase: true,
            testConnectionDataSource:false,
            testConnectionDatasourceName:"",
            testConnectionEnvName:"",
            testConnectionType:"",
            testConnectionStages:[],
            testConnectionStatusMessage:"",
            business_sub_tab: navigationState.businessSubTab === "domainMapping" ? "domainMapping" : "kpiCatalog",
            businessCatalogueLoading: false,
            businessCatalogueState: null,
            businessMappingsLoading: false,
            businessMappingsState: null,
            businessMappingsMetrics: null,
            tableRefreshKey: 0,
        }
    }

    loadBusinessCatalogue = () => {
        this.setState({ businessCatalogueLoading: true });
        hydrateConfigureCatalogueFromApi().then(({ state }) => {
            this.setState({
                businessCatalogueLoading: false,
                businessCatalogueState: state
            });
        });
    };

    sleepIntervalChanged(event) {
        let currInterval = parseInt(event.target.value);
        let isSleepIntervalMinErr = currInterval < MIN_SLEEP_TIME;
        let isSleepIntervalMaxErr = currInterval >= MAX_SLEEP_TIME;
        let sleepIntervalClass = Number(currInterval) === Number(this.state.prevSleepInterval) ? "d-none" : "";
        let errorMsg = "";
        if(isSleepIntervalMinErr){
            errorMsg = MIN_SLEEP_ERROR
        }
        else if(isSleepIntervalMaxErr) {
            errorMsg = MAX_SLEEP_ERROR;
        } else if (Number(currInterval) <= 0) {
            errorMsg = NEG_SLEEP_ERROR;
        }
        if (errorMsg.length > 0) {
            sleepIntervalClass = "d-none";
        }
        this.setState({
            sleepInterval: currInterval,
            isSleepIntervalErrMsg: errorMsg,
            sleepIntervalClass: sleepIntervalClass
        });
    }
    submitSleepInterval() {
        this.getApi("save_dd_sleep_time");
    }
    cancelSleepInterval() {
        let prevValue = Number(this.state.prevSleepInterval);
        this.setState({
            sleepInterval: prevValue,
            sleepIntervalClass: "d-none"
        });
    }

    setEnvData(data) {
        this.getAllDataSources();
        this.setState({ env_id: data })
    }

    handleIntegrationSaved(updatedIntegration) {
        const integrationId = updatedIntegration && updatedIntegration.integration_id;
        const integrationName = updatedIntegration && updatedIntegration.integration_name;

        if (integrationId === undefined || integrationId === null || !integrationName) {
            return;
        }

        const updateIntegrationDetails = (integrationDetails) => {
            if (!integrationDetails || String(integrationDetails.integration_id) !== String(integrationId)) {
                return integrationDetails;
            }

            let integrationConfig = integrationDetails.integration_config;
            if (Array.isArray(integrationConfig)) {
                integrationConfig = integrationConfig.map((config, index) => (
                    index === 0 ? { ...config, integration_name: integrationName } : config
                ));
            } else if (integrationConfig) {
                integrationConfig = { ...integrationConfig, integration_name: integrationName };
            }

            return {
                ...integrationDetails,
                integration_name: integrationName,
                integration_config: integrationConfig
            };
        };

        const data = this.state.data ? {
            ...this.state.data,
            data: this.state.data.data.map((row) => {
                const actionIndex = row.length - 1;
                const actionCell = row[actionIndex];
                const integrationDetails = actionCell && actionCell.integration_data;

                if (!integrationDetails || String(integrationDetails.integration_id) !== String(integrationId)) {
                    return row;
                }

                return row.map((cell, index) => {
                    if (index === 1) {
                        return { ...cell, value: integrationName };
                    }
                    if (index === actionIndex) {
                        return {
                            ...cell,
                            integration_data: updateIntegrationDetails(integrationDetails)
                        };
                    }
                    return cell;
                });
            })
        } : this.state.data;

        const integrationDetails = this.state.integration_details
            ? this.state.integration_details.map(updateIntegrationDetails)
            : this.state.integration_details;

        const integrationOption = this.state.integration_option
            ? this.state.integration_option.map(option => (
                String(option.value) === String(integrationId)
                    ? { ...option, label: integrationName }
                    : option
            ))
            : this.state.integration_option;

        this.setState({
            data: data,
            integration_details: integrationDetails,
            integration_option: integrationOption
        });
    }

    getExistingABData() {
        return this.state.currModelABList;
    }

    modelHasModelABConfiguration(model_id) {
        const modelABList = this.state.currModelABList;
        let hasModelABConfiguration = false;
        for (let currentAB of modelABList) {
            if (currentAB.model_1 === model_id) {
                hasModelABConfiguration = true;
                break;
            }
            if (currentAB.model_2 === model_id) {
                hasModelABConfiguration = true;
                break;
            }
            if (currentAB.model_3 === model_id) {
                hasModelABConfiguration = true;
                break;
            }
        }

        return hasModelABConfiguration;
    }

    componentDidCatch(error, info) {
        this.setState({ errorOccurred: true });
        this.postUIlogs(error, info);
    }

    handleModelABAddition(model_ab_data, model_info_map, isEdit) {
        let modelAbData = this.state.model_ab_data;
        let modelABList = this.state.currModelABList;

        let newData = [];
        if (isEdit) {
            let updatedABList = [];
            for (const currAB of modelABList) {
                if (currAB.model_ab_id !== model_ab_data.model_ab_id) {
                    updatedABList.push(currAB);
                    continue;
                }

                updatedABList.push(model_ab_data);
            }
            modelABList = updatedABList;

            // Update table row data
            let prevList = modelAbData["data"];
            for (const currRowData of prevList) {
                if (currRowData[6].model_ab_id !== model_ab_data.model_ab_id) {
                    newData.push(currRowData);
                    continue;
                }

                let abRowData = prepare_model_ab_data_for_a_config(model_ab_data, model_info_map);
                if (IS_NONE_CHECK.includes(abRowData)) {
                    continue;
                }

                newData.push(abRowData);
            }

        } else {
            // Adding the newly added model AB configuration to row data and state variable
            let abRowData = prepare_model_ab_data_for_a_config(model_ab_data, model_info_map)
            if (IS_NONE_CHECK.includes(abRowData)) {
                return;
            }

            modelABList.push(model_ab_data);

            let prevList = modelAbData["data"];
            newData = [abRowData, ...prevList];
        }

        modelAbData["data"] = newData;

        // Set the information to dataModule state
        this.props.setModelABDataToList(modelABList, model_info_map);

        // Setting information to Configure state
        this.setState({
            model_ab_data: modelAbData,
            currModelABList: modelABList,
            model_ab_updated: !this.state.model_ab_updated
        });
    }

    handleModelABDelete(model_ab_id) {
        let prevABData = this.state.model_ab_data;
        let modelABList = this.state.currModelABList.filter(x => String(x.model_ab_id) !== String(model_ab_id));

        // Updates the state variable for model AB table data so it will be removed from ui
        let newList = [];
        for (const rowData of prevABData["data"]) {
            const viewData = rowData[6];
            let currModel_ab_id = viewData["model_ab_id"];
            if (currModel_ab_id === model_ab_id) {
                // Skip the deleted Model AB id
                continue;
            }

            newList.push(rowData);
        }

        prevABData["data"] = newList;

        // Set the information to dataModule state
        this.props.setModelABDataToList(modelABList);

        this.setState({
            model_ab_data: prevABData,
            currModelABList: modelABList,
            model_ab_updated: !this.state.model_ab_updated
        });
    }

    componentDidMount() {
        let logoutPage = logoutPageRedirect()
        if (logoutPage) {
            return ''
        }

        this.getData()
        this.sectionNavigation();

        if (this.state.current_tab === "business") {
            this.loadBusinessCatalogue();
        }

        let prefetch = (Object.keys(this.props.dataModule.environmentDataSourceMapping).length !==
            Object.keys(this.props.dataModule.environments).length) ||
            (Object.keys(this.props.dataModule.integrations).length !==
                Object.keys(this.props.dataModule.relationship).length)
        let initial_prefetch = Object.keys(this.props.dataModule.environmentDataSourceMapping).length === 0 &&
            Object.keys(this.props.dataModule.environments).length === 0 &&
            Object.keys(this.props.dataModule.integrations).length === 0 &&
            Object.keys(this.props.dataModule.relationship).length === 0
        if (prefetch === true || initial_prefetch === true) {
            this.preFetch();
            // var intervalId = setInterval(this.preFetchMonitorGraph, 1000);
            // // store intervalId in the state so it can be accessed later:
            // this.setState({
            //     intervalId: intervalId
            // });
        }
        // this.preFetch();

    }


    /**Optimization changes */

    // preFetchMonitorGraph() {
    //     let teamID = localStorage.getItem('team_id')
    //     let tenantData = { "tenant_id": teamID };
    //     if (Object.keys(this.props.dataModule.integrations).length > 0) {
    //         clearInterval(this.state.intervalId);
    //         for (const key of Object.keys(this.props.dataModule.integrations)) {
    //             if (!(key in this.props.monitorModule.fetchInfo && this.props.monitorModule.fetchInfo[key])) {
    //                 preFetchMonitorInfo(
    //                     tenantData, this.props.addCompletenessDataSetInfo, this.props.addCompletenessAttributeInfo,
    //                     this.props.addTimelinessDataSetInfo, this.props.addTimelinessAttributeInfo,
    //                     this.props.addAccuracyDataSetInfo, this.props.addAccuracyAttributeInfo,
    //                     this.props.addConformityDataSetInfo, this.props.addConformityAttributeInfo,
    //                     this.props.addConsistencyDataSetInfo, this.props.addConsistencyAttributeInfo,
    //                     this.props.addDriftDataSetInfo, this.props.addDriftAttributeInfo, this.props.addMLDataSetInfo,
    //                     this.props.addMLAttributeInfo, this.props.addMonitorPreview, this.props.addUniquenessDataSetInfo,
    //                     this.props.addUniquenessAttributeInfo, this.props.addRecencyPreview,
    //                     this.props.prefetchMonitorState
    //                 );
    //             }
    //         }
    //     }
    // }

    // formData() {
    //     if (this.props.dataModule.metaData !== undefined) {
    //         const metaDataMapping = this.props.dataModule.metaData;
    //         const monitorDQListViewData = this.props.monitorModule.monitorDQListView;
    //         const timelinessShowMore = setDQShowMoreData(this.props.monitorModule.timelinessDataSetInfo,
    //             this.props.monitorModule.timelinessAttributeInfo, this.props.dataModule,
    //             null, DQ_MONITOR_SECTIONS.TIMELINESS);

    //         const mappedDatasetInfos = extractDatasetInfoForMonitorListView(metaDataMapping);
    //         const listViewTableDatas = getMonitorTabDQPListViewTableData(mappedDatasetInfos, monitorDQListViewData, this.props.monitorModule, timelinessShowMore);
    //         fromMonitorData(this.props.mappedDatasetInfo, this.props.listViewTableData, mappedDatasetInfos, listViewTableDatas, store)
    //         this.formDataOnce = 0
    //     }
    // }

    // preFetchMonitor() {
    //     let teamID = localStorage.getItem('team_id')
    //     let tenantData = { "tenant_id": teamID };

    //     // Monitor Prefetch
    //     // Prefetch happens for every Integrations
    //     // Gets the result and iterate for all integrations
    //     if (!this.props.dataModule.integrations) {
    //         for (const key of Object.keys(this.props.dataModule.integrations)) {
    //             if (!(key in this.props.monitorModule.fetchInfo && this.props.monitorModule.fetchInfo[key])) {
    //                 preFetchMonitorInfo(
    //                     tenantData, this.props.addCompletenessDataSetInfo, this.props.addCompletenessAttributeInfo,
    //                     this.props.addTimelinessDataSetInfo, this.props.addTimelinessAttributeInfo,
    //                     this.props.addAccuracyDataSetInfo, this.props.addAccuracyAttributeInfo,
    //                     this.props.addConformityDataSetInfo, this.props.addConformityAttributeInfo,
    //                     this.props.addConsistencyDataSetInfo, this.props.addConsistencyAttributeInfo,
    //                     this.props.addDriftDataSetInfo, this.props.addDriftAttributeInfo, this.props.addMLDataSetInfo,
    //                     this.props.addMLAttributeInfo, this.props.addMonitorPreview, this.props.addUniquenessDataSetInfo,
    //                     this.props.addUniquenessAttributeInfo, this.props.addRecencyPreview,
    //                     this.props.prefetchMonitorState
    //                 );
    //             }
    //         }
    //     }

    // }

    // preFetchData() {
    //     let teamID = localStorage.getItem('team_id')
    //     let tenantData = { "tenant_id": teamID };

    //     // Data Prefetch
    //     // Single Api call and interating the result to get exact metadata values
    //     if (!this.props.dataModule.preFetchMetaData) {
    //         preFetchMetaData(
    //             tenantData, this.props.addMetaData, this.props.addEnvironment,
    //             this.props.addEnvironmentDataSourceMapping, this.props.addDataSourceDataSetMapping,
    //             this.props.addDataSetAttributeMapping, this.props.setDataSet, this.props.setAttribute,
    //             this.props.setDataSource, this.props.setMlDataSource, this.props.addRelationship, this.props.addDataSource,
    //             this.props.addInfo, this.props.addLastProfilingTime, this.props.setStartDate, this.props.setEndDate, this.props.addDiscoveryStatus,
    //             this.props.addProcessingStatus, this.props.noIntegration
    //         );
    //     }
    // }

    /**Optimization changes Ends*/


    preFetch() {
        let teamID = localStorage.getItem('team_id')
        let tenantData = { "tenant_id": teamID };

        // Monitor Prefetch.
        // Single api call : /model_performance/results/info
        // if (!this.props.monitorModule.preFetchMonitorPreview) {
        //     preFetchMonitorPreview(tenantData, this.props.addMonitorPreview, this.props.addPerformancePreview,
        //         this.props.addModelPerformance);
        // }
        if (!this.props.monitorModule.lastProfilingTime){
            getLastProfilingTime(tenantData, this.props.addLastProfilingTime, this.props.setStartDate, this.props.setEndDate,);
        }
        // // Data Prefetch
        // // Single Api call and interating the result to get exact metadata values
        if (!this.props.dataModule.preFetchMetaData) {
            preFetchMetaData(
                tenantData, this.props.addMetaData, this.props.addEnvironment,
                this.props.addEnvironmentDataSourceMapping, this.props.addDataSourceDataSetMapping,
                this.props.addDataSetAttributeMapping, this.props.setDataSet, this.props.setAttribute,
                this.props.setDataSource, this.props.setMlDataSource, this.props.addRelationship, this.props.addDataSource,
                this.props.addInfo, this.props.addLastProfilingTime, this.props.setStartDate, this.props.setEndDate, this.props.addDiscoveryStatus,
                this.props.addProcessingStatus, this.props.noIntegration
            );
        }
        // // Monitor Prefetch
        // // Prefetch happens for every Integrations
        // // Gets the result and iterate for all integrations
        // if (!this.props.dataModule.integrations) {
            // for (const key of Object.keys(this.props.dataModule.integrations)) {
                    // if (!(key in this.props.monitorModule.fetchInfo && this.props.monitorModule.fetchInfo[key])) {
                    //     preFetchMonitorInfo(
                    //         tenantData, this.props.addCompletenessDataSetInfo, this.props.addCompletenessAttributeInfo,
                    //         this.props.addTimelinessDataSetInfo, this.props.addTimelinessAttributeInfo,
                    //         this.props.addAccuracyDataSetInfo, this.props.addAccuracyAttributeInfo,
                    //         this.props.addConformityDataSetInfo, this.props.addConformityAttributeInfo,
                    //         this.props.addConsistencyDataSetInfo, this.props.addConsistencyAttributeInfo,
                    //         this.props.addDriftDataSetInfo, this.props.addDriftAttributeInfo, this.props.addMLDataSetInfo,
                    //         this.props.addMLAttributeInfo, this.props.addMonitorPreview, this.props.addUniquenessDataSetInfo,
                    //         this.props.addUniquenessAttributeInfo, this.props.addRecencyPreview,
                    //         this.props.prefetchMonitorState
                    //     );
                    // }
            // }
        // }

        // // Monitor Model Prefetch : model/map
        // // store the value in redux
        // if (!this.props.monitorModule.preFetchMonitorModelInfo) {
        //     preFetchMonitorModelInfo(
        //         teamID, this.props.addMLModelMapping,
        //         this.props.addMLDataSetInfo, this.props.addMLAttributeInfo,
        //         this.props.addMLModel, this.props.setMLModel
        //     );
        // }

        // // ML Monitor prefetch : ml-models
        // // Profile ML filter and ML tab
        // if (!this.props.monitorModule.preFetchModelDetails) {
        //     preFetchModelDetails(teamID, this.props.addModelDetails);
        // }

        // custom Metrics Prefetch used in custom metric page
        // Fetch and Store
        if (!this.props.monitorModule.preFetchMetrics) {
            preFetchMetrics(teamID, this.props.addMetrics);
        }

        //    Monitor Prefetch
        // Prefetch happens for every Integrations
        // Gets the result and iterate for all integrations
        // if (!this.props.monitorModule.preFetchMonitorListViewData) {
        //     preFetchMonitorListViewData(teamID, this.props.addMonitorDQListViewData);
        // }

        //    Notification Prefetch: user_notification/unread
        //    Used in navigation header
        //    Fetch and store
        if (!this.props.dataModule.preFetchUserNotifications) {
            // Fetch first page result of user notifications
            preFetchUserNotifications(tenantData, addUserNotificationToState, store);
        }

        //  Data Prefetch: /datasets
        //  Used in charts discover, profile
        //  Fetch and store
        if (!this.props.dataModule.prefetchDatasetDetails) {// Fetch dataset version details
            prefetchDatasetDetails(tenantData, addDatasetVersions, store);
        }

        // Data Prefetch: recency/all
        // Used in Discovery and profile
        // Fetch and store
        if (!this.props.dataModule.prefetchRecencyDetails) {// Fetch Recency Details
            prefetchRecencyDetails(tenantData, addRecencyDetails, store);
        }

        // Discover prefetch: recent_search
        // user in discover page
        // fetch and store
        if (!this.props.dataModule.prefetchRecentHistory) { // Fetch recent search history - discover page
            prefetchRecentHistory(tenantData, addRecentHistory, store);
        }

        // Fetch and store datasize : /data_size
        // simple prefetch
        if (!this.props.dataModule.prefetchDataSize) {// Fetch data size - discover page
            prefetchDataSize(tenantData, addDataSize, store)
        }

        // Monitor Model Prefetch used in configure and monitor : model_ab_data
        // if (!this.props.dataModule.prefetchModelABData) { // Fetch Model AB configuration list
        //     prefetchModelABData(tenantData, setModelABDataToList, store);
        // }

        // Monitor Prefetch: follow_attributes
        // used in monitor page
        // fetch and store
        // if (!this.props.monitorModule.preFetchFollowAttributes) {
        //     preFetchFollowAttributes(tenantData, addFollowAttributes, store);
        // }

        //    Alert Prefetch : alert_applicable_metrics
        //    used on alert page
        if (!this.props.monitorModule.preFetchMetadataDetails) {
            preFetchMetadataDetails(tenantData, storeMetadataDetails, store)
        }
    }

    setDataLimit() {
        this.getApi("increaseDataLimit");
    }

    showModelABConfigureSection(tableRowProps, canShowABModal, closeModalFunction, handleModelABAddition) {
        return (
            <ConfigureABTest tableRowProps={tableRowProps}
                operation={"ab_add"}
                handleModelABAddition={handleModelABAddition}
                canShowABModal={canShowABModal}
                closeModalFunction={closeModalFunction}
            />
        );
    }

    async getAllDataSources() {
        let headers=["Environment", "Datasource Name", "Datasource Type", "Status ", "Created Date", "Actions"];
         let teamID = localStorage.getItem('team_id');
        let requestPayload = {"tenant_id":teamID}
        const allDataSourcesData = await getAllDataSources(requestPayload);
        if (allDataSourcesData && allDataSourcesData.code === 200) {
        let input_data = (allDataSourcesData && allDataSourcesData.datasources) || []
        let final_op=[];
        for(let i=0; i < input_data.length; i++) {
            let row=[];
            let d= input_data[i];
            row.push({"value": d["env_name"], "type": "td"});
            row.push({"value": d['datasource_name'], "type": "td"});
            row.push({"value": d['connector_type'], "type": "td"});
            row.push({"value": d['auto_config_status'], "type": "td"});
            row.push({"value": d['created_time'], "type": "td"});
            row.push({"value": "", "type": "component", "advanced_configuration_data":d});
            final_op.push(row);
        }
        let table_data ={"headers": headers, "data": final_op}
        this.setState({ allDataSourcesData: table_data, allDataSourcesList: input_data });
        }else {
        let table_data ={"headers": headers, "data": []}
         this.setState({ allDataSourcesData: table_data, allDataSourcesList: [] });
        }
    }

    /**
     * Called by the Datasource edit form after fetching fresh datasource details.
     * Updates only the "Status " cell of the matching row so the table reflects
     * the latest auto_config_status without a full table refresh.
     */
    onAutoConfigStatusUpdate = (datasource_id, newStatus) => {
        if (!datasource_id || !this.state.allDataSourcesData) return;
        const STATUS_COL_INDEX = 3; // "Status " column
        const ACTIONS_COL_INDEX = 5; // "Actions" column (contains advanced_configuration_data)
        const updatedData = this.state.allDataSourcesData.data.map(row => {
            const actionsCell = row[ACTIONS_COL_INDEX];
            if (actionsCell && actionsCell.advanced_configuration_data &&
                String(actionsCell.advanced_configuration_data.datasource_id) === String(datasource_id)) {
                const updatedRow = [...row];
                updatedRow[STATUS_COL_INDEX] = { ...updatedRow[STATUS_COL_INDEX], value: newStatus };
                // Also update the status inside advanced_configuration_data so the delete guard is consistent
                updatedRow[ACTIONS_COL_INDEX] = {
                    ...actionsCell,
                    advanced_configuration_data: {
                        ...actionsCell.advanced_configuration_data,
                        auto_config_status: newStatus
                    }
                };
                return updatedRow;
            }
            return row;
        });
        this.setState({
            allDataSourcesData: {
                ...this.state.allDataSourcesData,
                data: updatedData
            }
        });
    }

    getData() {
        this.getApi("accountDetails");
        this.getApi("environments");
        this.getApi("integrations");
        this.getApi("dataset");
        this.getApi("datasource_updates");
        this.getAllDataSources();



        // let teamID = localStorage.getItem('team_id')
        // let tenantData = { "tenant_id": teamID };

        let hideConfPageModelTab = false;
        if (!IS_NONE_CHECK.includes(this.state.featureAccess)) {
            const confPageData = this.state.featureAccess["models"];
            hideConfPageModelTab = confPageData === false;
        }

        this.getApi("dd_sleep_time_fetch");
        if (!hideConfPageModelTab) {
            // When models feature is disabled, no need to call model related apis.
            // return;
            this.getApi("mlmodels");
            this.getApi("model_updates");
            this.getApi("modelABData");
    
        }
       

        if (!IS_NONE_CHECK.includes(this.state.featureAccess)){
            let confPagePipelineDatamout = this.state.featureAccess["pipeline"];
            if(confPagePipelineDatamout!==undefined){
                if(confPagePipelineDatamout === true){
                    this.getApi("pipeline_integrations");
                    this.getApi("pipelinesource_updates");
                }
            }
        }


        if (!IS_NONE_CHECK.includes(this.state.featureAccess)){
            let confPagePipelineDatamout = this.state.featureAccess["pipeline"];
            if(confPagePipelineDatamout!==undefined){
                if(confPagePipelineDatamout === true){
                    this.getApi("pipeline_integrations");
                    this.getApi("pipelinesource_updates");
                }
            }
        }
   }

    updateEnvironmentList(newEnvironmentData) {
        //Adds the newly added environment information to existing list
        const existingEnvironmentDetail = this.state.environment;
        if (existingEnvironmentDetail === undefined || existingEnvironmentDetail === null) {
            return;
        }

        if (newEnvironmentData === undefined || newEnvironmentData === null) {
            return;
        }

        let data = { "label": newEnvironmentData.env_name, "value": newEnvironmentData.env_id };
        existingEnvironmentDetail.push(data);
        this.setState({ environment: existingEnvironmentDetail });
    }

    setAddModel(value) {
        this.setState({ isAddModel: value });
        if (value) {
            this.setModelVersion(false);
        }
    }

    setModelVersion(value) {
        if (value) {
            this.setAddModel(false);
        }

        this.setState({ isModelVersion: value });
    }

    setAddDS(value) {
        this.setState({ isAddDS: value });
    }

    async testConnectionIntegration(testconnectionIntegration) {
            this.setState(
            {
                testConnectionDataSource: true,
                testConnectionDatasourceName: testconnectionIntegration.datasource_name,
                testConnectionEnvName: testconnectionIntegration.env_name,
                testConnectionType: testconnectionIntegration.connector_type,
                testConnectionStages: []
            },
            async () => {
                let teamId = localStorage.getItem('team_id');
                let userId = localStorage.getItem('user_id');

                let data = {
                datasource_id: testconnectionIntegration.datasource_id,
                tenant_id: teamId,
                user_id: userId,
                env_id: testconnectionIntegration.env_id,
                is_config_details: 'False',
                isTestConnection: 'True',
                integration_id: testconnectionIntegration.integration_id
                };

                let response = await testIntegration(data);

                if (response && response.status_code) {
                this.setState({
                    testConnectionStages: response.stages,
                    testConnectionStatusMessage: response.status_message
                });
                }
            }
            );
    }

    viewAction(actions){
        this.setState({viewAction:actions})
    }

    async testConnectionDataSource(testconnectionDataSource) {
        
        this.setState({testConnectionDataSource:true,
            testConnectionDatasourceName:testconnectionDataSource.datasource_name,
            testConnectionEnvName:testconnectionDataSource.env_name,
            testConnectionType:testconnectionDataSource.connector_type,
            testConnectionStages:[]
            })

          if (testconnectionDataSource.datasource_id !== undefined && testconnectionDataSource.datasource_id !== null) {
            let teamId = localStorage.getItem('team_id');
            let userId = localStorage.getItem('user_id');
            let data = {datasource_id:testconnectionDataSource.datasource_id, tenant_id:teamId,user_id:userId,env_id:testconnectionDataSource.env_id};
            let response =  await editDataSource(data);
             if (response.code === 200) {

            const requestPayload = {
            datasource_name: response.datasource.datasource_name || "Test Dataset",
            tenant_id: localStorage.getItem('team_id'), // You may want to get this from props or auth
            env_id: response.datasource.env_id ,
            datasource_type: response.datasource.connector_type,
            data_store_type: response.datasource.data_store_type,
            datasource_config: response.datasource.datasource_config,
            auth_config: response.datasource.auth_config
        };

        //    testConnectionDatasourceName:"",
        //     testConnectionEnvName:"",
        //     testConnectionType:"",
        //     testConnectionStages:[],


                let testresponse =  await testDataSource(requestPayload);
                  if (testresponse.status_code) {
                        this.setState({
                        testConnectionStages:testresponse.stages,
                        testConnectionStatusMessage:testresponse.status_message
                        })
                  }

                //    let integration_details = response.datasource;
             }
            }
    }


    testConnectionDataSourceClose() {
        this.setState({
            testConnectionDataSource:false,
            testConnectionDatasourceName:"",
            testConnectionEnvName:"",
            testConnectionType:"",
            testConnectionStages:[],
            testConnectionStatusMessage:""
        })
    }

    

    closeToast() {
        this.setState({ toastStatus: false });
    }

    updateTable() {
        this.setState({ updateStatus: false }, this.getApi("integrations"));
    }

    /**
     * Called immediately after an integration is deleted from the Configured Integrations table.
     * Removes the row from state optimistically so the UI updates without waiting for the API re-fetch.
     */
    onIntegrationDeleted(integration_id) {
        if (!integration_id || !this.state.data) return;
        const updatedRows = this.state.data.data.filter(row => {
            const actionCell = row[row.length - 1];
            const id = actionCell && actionCell.integration_data && actionCell.integration_data.integration_id;
            return String(id) !== String(integration_id);
        });
        const updatedIntegrationDetails = (this.state.integration_details || []).filter(
            item => String(item.integration_id) !== String(integration_id)
        );
        this.setState(prevState => ({
            data: { ...this.state.data, data: updatedRows },
            integration_details: updatedIntegrationDetails,
            tableRefreshKey: prevState.tableRefreshKey + 1
        }));
    }

    /**
     * Called immediately after a datasource is deleted from the Configured DataSources table.
     * Removes the row from state optimistically so the UI updates without waiting for the API re-fetch.
     */
    onDatasourceDeleted(datasource_id) {
        if (!datasource_id || !this.state.allDataSourcesData) return;
        const ACTIONS_COL_INDEX = 5;
        const updatedRows = this.state.allDataSourcesData.data.filter(row => {
            const actionsCell = row[ACTIONS_COL_INDEX];
            const id = actionsCell && actionsCell.advanced_configuration_data && actionsCell.advanced_configuration_data.datasource_id;
            return String(id) !== String(datasource_id);
        });
        const updatedList = (this.state.allDataSourcesList || []).filter(
            item => String(item.datasource_id) !== String(datasource_id)
        );
        this.setState(prevState => ({
            allDataSourcesData: { ...this.state.allDataSourcesData, data: updatedRows },
            allDataSourcesList: updatedList,
            tableRefreshKey: prevState.tableRefreshKey + 1
        }));
    }

    showToast(status, msg, link, bulk, reloadData = true) {
        if (reloadData) {
            this.getData();
        }

        const toastStatusMap = {
            success: "alert-success",
            error: "alert-danger",
            warning: "alert-warning"
        };
        const toastStatus = toastStatusMap[status] || status;
        const toastConfig = toastObj[toastStatus] || toastObj["alert-danger"];

        this.setState(prevState => ({
            toastStatus: true,
            toastMsg: msg,
            toastClass: toastConfig["className"],
            toastIcon: toastConfig["icon"],
            toastLink: link,
            toastHeading: toastConfig["heading"],
            toastBulk: bulk,
            tableRefreshKey: prevState.tableRefreshKey + 1
        }));
    }

    getModelABTableComponent(actionType, headerValue, cell, tableProps) {
        // This is a call back function called from QualdoDataTable - convertData() function

        if (headerValue === "Model Name") {
            const names = cell;
            return (
                <>
                    <div className="abtested_cell abtested_start">
                        <span className="abtest_parent">A</span>
                        {names[0]}
                    </div>

                    <div className="abtested_cell abtested_end">
                        <span className="abtest_child">B</span>
                        {names[1]}
                    </div>

                    {names[2] === undefined ? '' :
                        <div className="abtested_cell abtested_end">
                            <span className="abtest_nextchild">C</span>
                            {names[2]}
                        </div>
                    }

                </>
            )

        }

        const divDupHeaders = ["Model Version", "Datasource", "Environment"];
        if (divDupHeaders.includes(headerValue)) {
            const modelDataStrings = cell;
            return (
                <>
                    <div>{modelDataStrings[0]}</div>

                    <div>{modelDataStrings[1]}</div>

                    {modelDataStrings[2] === undefined ? '' :
                        <div>{modelDataStrings[2]}</div>
                    }

                </>
            )

        }

        const emptyDivHeaders = ["Created By", "Created Time"];
        if (emptyDivHeaders.includes(headerValue)) {
            const cellValue = cell.value;
            const has3Models = cell.has3Models;
            return (
                <>
                    <div>{cellValue}</div>

                    <div />

                    {has3Models ? <div /> : ''}
                </>
            )

        }

        if (headerValue === "Actions") {
            return (
                <>
                    <ModelABEdit data={cell}
                        modelABTableProps={tableProps}
                        showToast={this.showToast}
                        handleModelABDelete={this.handleModelABDelete}
                    />

                    <div />

                    {cell.has3Models === true ? <div /> : ''}
                </>

            );
        }


        return cell;
    }

    getModelABTableIDFormatter(cell, row, rowIndex) {
        const has3Models = row["Created By"].has3Models;

        return (
            <>
                <div>{row["ID"]}</div>
                <div />
                {has3Models ? <div /> : ''}
            </>
        );
    }

    renderModelABTable(key) {
        if (this.state.mlData === null || this.state.mlDetails === null) {
            return '';
        }

        // Used in Model AB configurations
        const mlDropDown = formModelVersionMap(this.state.mlDetails);
        const tableData = this.state.model_ab_data;

        if (tableData === null) {
            return <BasicPortlet
                className="pb-0"
                id="configuredABModelsLoading"
                title={AB_MODELS_TABLE_TITLE}
                content={
                    <Load />
                }
            />
        }

        let reqKey = this.state.model_ab_updated ? "reloadAB" : "abTableNormal";
        return <div id="jump-to_configured-model-ab-testing" className="mb-15"><BasicPortlet
            className="pb-0"
            id="configuredABModelsLoading"
            title={AB_MODELS_TABLE_TITLE}
            content={
                <QualdoDataTable
                    key={reqKey}
                    handleModelABAddition={this.handleModelABAddition}
                    customGetActionComponent={this.getModelABTableComponent}
                    data={tableData}
                    tableIDFormatter={this.getModelABTableIDFormatter}
                    showToast={this.showToast}
                    paginationSize={3}
                    pageOptions={[3, 6]}
                    handleModelABDelete={this.handleModelABDelete}
                    component_name="modelABTestTable"
                    classNameForTable={"table table_custom-rowspan abtested-table"}
                    availableModels={mlDropDown["modelsDropDown"]}
                    modelsDataMap={mlDropDown["modelsDataMap"]}
                    getExistingABData={this.getExistingABData}
                    modelVersionMap={mlDropDown["modelVersionMap"]}
                    modelTypeMap={mlDropDown["modelTypeMap"]}
                    setEnvData={this.setEnvData}
                />
            }
        />
        </div>

    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.state.testConnectionDataSource !== nextState.testConnectionDataSource || this.state.testConnectionStages !== nextState.testConnectionStages) {
            return true;
        }
        // Re-render immediately when a deletion triggers a tableRefreshKey increment
        if (this.state.tableRefreshKey !== nextState.tableRefreshKey) {
            return true;
        }
        if (get_api_call_cnt > 4 && (get_api_call_cnt - 1 === get_api_call_complete_cnt || get_api_call_cnt === get_api_call_complete_cnt) && post_api_call_cnt === post_api_call_complete_cnt) {
            this.pre_load = false;
            return true;
        }
        else {
            return false;
        }
    }

    renderTableds(key) {
        const reqKey = `integrations_${this.state.tableRefreshKey}_${this.state.data ? this.state.data.data.length : 'empty'}`;

        if (key === "ds" && this.state.data !== null) {

            return <div id="jump-to_configure-datasource" className="mb-15"><BasicPortlet
                className="pb-0"
                key={reqKey}
                id="configuredDatasources"
                title="Configured Integrations"
                content={
                    <QualdoDataTable
                        id="configuredDatasources"
                        data={this.state.data}
                        showToast={this.showToast}
                        environment={this.state.environment}
                        component_name="datasource"
                        updateTable={this.updateTable}
                        setEnvData={this.setEnvData}
                        setAddDS={this.setAddDS}
                        onIntegrationSaved={this.handleIntegrationSaved}
                        onIntegrationDeleted={this.onIntegrationDeleted}
                        testConnectionIntegration={this.testConnectionIntegration}
                        allDataSourcesList={this.state.allDataSourcesList}
                        allIntegrationsList={this.state.data}
                        existingIntegrations={this.state.integration_details}
                        onAutoConfigStatusUpdate={this.onAutoConfigStatusUpdate}
                    />
                }
            />
            </div>
        }
        else if (key === "ds" && this.state.data === null) {
            return <BasicPortlet
                className="pb-0"
                id="configuredDatasourcesLoading"
                title="Configured Integrations"
                content={
                    <Load />
                }
            />
        }
    }

    renderTablesDatasources(key) {
        const reqKey = `datasources_${this.state.tableRefreshKey}_${this.state.allDataSourcesData ? this.state.allDataSourcesData.data.length : 'empty'}`;

        if (key === "ds" && this.state.allDataSourcesData !== null) {
            return <div id="jump-to_configure-datasource" className="mb-15"><BasicPortlet
                className="pb-0"
                key={reqKey}
                id="configuredDatasources"
                title="Configured DataSources"
                content={
                    <QualdoDataTable
                        id="configuredDatasources"
                        data={this.state.allDataSourcesData}
                        showToast={this.showToast}
                        environment={this.state.environment}
                        component_name="configuredDatasourcesAdvanced"
                        updateTable={this.updateTable}
                        setEnvData={this.setEnvData}
                        setAddDS={this.setAddDS}
                        testConnectionDataSource={this.testConnectionDataSource}
                        allDataSourcesList={this.state.allDataSourcesList}
                        existingIntegrations={this.state.integration_details}
                        onAutoConfigStatusUpdate={this.onAutoConfigStatusUpdate}
                        onDatasourceDeleted={this.onDatasourceDeleted}
                    />
                }
            />
            </div>
        }
        else if (key === "ds" && this.state.allDataSourcesData === null) {
            return <BasicPortlet
                className="pb-0"
                id="configuredDatasourcesLoading"
                title="Configured DataSources"
                content={
                    <Load />
                }
            />
        }
    }

    renderScanIntervalContent() {
        if (this.state.sleepComponentLoad) {
            return (
                <Load />
            );
        }

        let disableConfigureAction = checkPermissions('Configure')

        return (
            <>
                <p className="mb-4">
                    Scan interval defines the minimum waiting time, in minutes,
                    between the successive scans to identify
                    refreshed datasets of the datasource
                </p>
                <div className='row'>
                    <div className='col-md-6 col-xl-4'>

                <Form.Group>
                    <Form.Label className="position-relative">
                        Time Interval
                        <RcTooltip
                            placement="top"
                            overlay={
                                <span>
                                    {`Set the time duration less than ${MAX_SLEEP_TIME} minutes`}
                                </span>
                            }
                            arrowContent={<div className="rc-tooltip-arrow-inner"></div>}
                        >
                            <i className="icon-info-circle"></i>
                        </RcTooltip>
                    </Form.Label>

                    <div className="datarefresh-interval">
                        <Form.Control
                            disabled = {disableConfigureAction}
                            type="number"
                            value={this.state.sleepInterval}
                            onChange={this.sleepIntervalChanged}
                            className="datarefresh-interval__form"
                        />
                        <span>minutes</span>
                    </div>

                    {
                        this.state.isSleepIntervalErrMsg.length > 0 ?
                            <span className="error-text">
                                {this.state.isSleepIntervalErrMsg}
                            </span>
                            :
                            ''
                    }
                </Form.Group>

                <div className={"mt-4 " + this.state.sleepIntervalClass}>
                    <Button
                        disabled={this.state.isSleepIntervalErrMsg.length > 0 || isNaN(this.state.sleepInterval)}
                        onClick={this.submitSleepInterval}
                        type="submit"
                        className="btn-primary btn-circle mr-2"
                    >
                        <i>
                            <FontAwesomeIcon icon={faCheck} />
                        </i>
                        Save Changes
                    </Button>
                    <Button
                        onClick={this.cancelSleepInterval}
                        type="submit"
                        className="btn-outline btn-grey btn-circle"
                    >Cancel</Button>
                </div>
                </div>
                </div>
            </>
        );
    }

    renderScanIntervalComponents() {
        return (
            <div id="jump-to_datarefresh-interval" className="mb-3 d-none">
                <BasicPortlet
                    title="Data Refresh Interval"
                    content={this.renderScanIntervalContent()}
                />
            </div>
        );
    }

    renderTablepipeline(key) {
        let reqKey = 'empty';
        if (this.state.integration !== undefined && this.state.integration !== null) {
            reqKey = this.state.integration.length;
        }
        if (this.state.pipelinedata !== null) {
            return <div id="jump-to_configure-pipeline" className="mb-15"><BasicPortlet
                        className="pb-0"
                        key={reqKey}
                        id="configuredPipelinesource"
                        title="Configured Pipeline Sources"
                        content={
                                    <QualdoDataTable
                                        id="configuredPipelinesource"
                                        data={this.state.pipelinedata}
                                        showToast={this.showToast}
                                        environment={this.state.environment}
                                        component_name="pipelinesource"
                                        updateTable = {this.updateTable}
                                        setEnvData={this.setEnvData}
                                    />
                                }
                   />
                   </div>
        }
        else if (this.state.pipelinedata === null){
             return <BasicPortlet
                        className="pb-0"
                        id="configuredPipelinesourceLoading"
                        title="Configured Pipeline Sources"
                        content={
                                    <Load />
                                }
                   />
        }
    }


    // renderTablepipeline(key) {
    //     let reqKey = 'empty';
    //     if (this.state.integration !== undefined && this.state.integration !== null) {
    //         reqKey = this.state.integration.length;
    //     }
    //     if (this.state.pipelinedata !== null) {
    //         return <div id="jump-to_configure-pipeline" className="mb-15"><BasicPortlet
    //                     className="pb-0"
    //                     key={reqKey}
    //                     id="configuredPipelinesource"
    //                     title="Configured Pipeline Sources"
    //                     content={
    //                                 <QualdoDataTable
    //                                     id="configuredPipelinesource"
    //                                     data={this.state.pipelinedata}
    //                                     showToast={this.showToast}
    //                                     environment={this.state.environment}
    //                                     component_name="pipelinesource"
    //                                     updateTable = {this.updateTable}
    //                                     setEnvData={this.setEnvData}
    //                                 />
    //                             }
    //                />
    //                </div>
    //     }
    //     else if (this.state.pipelinedata === null){
    //          return <BasicPortlet
    //                     className="pb-0"
    //                     id="configuredPipelinesourceLoading"
    //                     title="Configured Pipeline Sources"
    //                     content={
    //                                 <Load />
    //                             }
    //                />
    //     }
    // }

    renderRefreshTable(data, key) {
        let reqKey = 'empty';
        if (this.state.integration !== undefined && this.state.integration !== null) {
            reqKey = this.state.integration.length;
        }
        if (key === 'data') {
            return (
                <div id="jump-to_processerror" >
                    <BasicPortlet
                        id={this.state.datasourceErrorRefreshesId}
                        key={reqKey}
                        title="Processing Errors & Data Refresh Status"
                        content={
                            (data === null) ?
                                <Load />
                                :
                                (data.data.length === 0 ?
                                    <NoErrorInPreview NoModelComponent ={true} component_name='datasource'/>
                                    :
                                    <RefreshesTable componentName="datasource"
                                        data={data}
                                        id={this.state.datasourceErrorRefreshesId}
                                        updateStatus={this.state.updateStatus}
                                    />
                                )
                        }
                    />
                </div>
            )
        }
        else if(key==='ml'){
            return(
                <div id="jump-to_model-processing-errors">
                    <BasicPortlet
                        id={this.state.modelRefreshesId}
                        title="Model Processing Errors & Refresh Status"
                        content={
                            (data === null
                                ?
                                <Load />
                                :
                                (data.length === 0 ?
                                        <NoErrorInPreview component_name = "ml_model" NoModelComponent={true} />

                                    :
                                    <RefreshesTable componentName="model"
                                        data={data}
                                        id={this.state.modelRefreshesId}
                                        updateStatus={this.state.updateStatus}

                                    />
                                )
                            )
                        }
                    />
                </div>
            )
        }
        else if(key==='pipeline'){

            return(
                <div id="jump-to_pipelineprocesserror" >
                    <BasicPortlet
                        id={this.state.pipelinesourcesRefreshesId}
                        key={reqKey}
                        title="Processing Errors & Pipeline Status"
                        content={
                            (data !== null)?
                                <RefreshesTable componentName="pipelinesource"
                                                data={data}
                                                id={this.state.pipelinesourcesRefreshesId}
                                                />
                            :
                                <Load/>
                        }
                    />
                </div>
            )
            // return(
            //         <div id="jump-to_pipelineprocesserror">
            //             <BasicPortlet
            //                 id={this.state.pipelinesourcesRefreshesId}
            //                 title="Processing Errors & Pipeline Status"
            //                 content={
            //                     data !== null ?
            //                         <RefreshesTable componentName="pipelinesource"
            //                                         data={data}
            //                                         id={this.state.pipelinesourcesRefreshesId}/> :
            //                         <Load/>
            //                 }
            //             />
            //             </div>
            // )
        }
        else if(key==='pipeline'){

            return(
                <div id="jump-to_pipelineprocesserror" >
                    <BasicPortlet
                        id={this.state.pipelinesourcesRefreshesId}
                        key={reqKey}
                        title="Processing Errors & Pipeline Status"
                        content={
                            (data !== null)?
                                <RefreshesTable componentName="pipelinesource"
                                                data={data}
                                                id={this.state.pipelinesourcesRefreshesId}
                                                />
                            :
                                <Load/>
                        }
                    />
                </div>
            )
            // return(
            //         <div id="jump-to_pipelineprocesserror">
            //             <BasicPortlet
            //                 id={this.state.pipelinesourcesRefreshesId}
            //                 title="Processing Errors & Pipeline Status"
            //                 content={
            //                     data !== null ?
            //                         <RefreshesTable componentName="pipelinesource"
            //                                         data={data}
            //                                         id={this.state.pipelinesourcesRefreshesId}/> :
            //                         <Load/>
            //                 }
            //             />
            //             </div>
            // )
        }

        if(data!== null && data.length>0){
            this.setState({updateStatus:false})
        }
    }

    renderTableml(key) {

        if (key === "ml" && this.state.mlData !== null) {
            const mlDropDown = formModelVersionMap(this.state.mlDetails);
            return <div id="jump-to_configuredModels" className="mb-15">
                <BasicPortlet
                    className="pb-0"
                    id="configuredModels"
                    title="Configured Models"
                    content={
                        <QualdoDataTable
                            showModelABPopup={this.showModelABConfigureSection}
                            handleModelABAddition={this.handleModelABAddition}
                            modelHasModelABConfiguration={this.modelHasModelABConfiguration}
                            data={this.state.mlData}
                            showToast={this.showToast}
                            integrationOption={this.state.integration_option}
                            environment={this.state.environment}
                            component_name="ml_model"
                            datasets={this.state.datasets}
                            availableModels={mlDropDown["modelsDropDown"]}
                            modelsDataMap={mlDropDown["modelsDataMap"]}
                            getExistingABData={this.getExistingABData}
                            modelVersionMap={mlDropDown["modelVersionMap"]}
                            modelTypeMap={mlDropDown["modelTypeMap"]}
                            attributes={this.state.attributes}
                        />
                    }
                />
            </div>

        }
        else if (key === "ml" && this.state.mlData === null) {
            return <BasicPortlet
                className="pb-0"
                id="configuredModelsLoading"
                title="Configured Models"
                content={
                    <Load />
                }
            />
        }
    }

    handleTab(key) {
        postMixpanel("Configure -> " + key + "tab Page")
        if (key === "business") {
            this.setState({
                current_tab: key,
                business_sub_tab: "kpiCatalog",
                businessCatalogueLoading: true
            });
            hydrateConfigureCatalogueFromApi().then(({ state }) => {
                this.setState({
                    businessCatalogueLoading: false,
                    businessCatalogueState: state
                });
            });
            return;
        }
        this.setState({ current_tab: key });
    }

    sectionNavigation() {
        document.querySelectorAll('.breadcrumb-direct-section li a[href*="#"]').forEach(anchor => {
            anchor.addEventListener('click', function (e) {
                e.preventDefault();
                var topOfElement = document.querySelector(this.getAttribute('href')).offsetTop;
                window.scroll({ top: topOfElement - 80, behavior: "smooth" });
            });
        });
    }

    handleConfigureProgressCollapse = () => {
        this.setState({configureProgressCollpase : false})
    }

    render() {

        
        let logoutPage = logoutPageRedirect()
        if (logoutPage) {
            return ''
        }
        let hideConfPageModelTab = true;
        if (!IS_NONE_CHECK.includes(this.state.featureAccess)) {
            const confPageData = this.state.featureAccess["models"];
            hideConfPageModelTab = confPageData === false;
        }

        let hidebusinessMappingTab = false;
        if (!IS_NONE_CHECK.includes(this.state.featureAccess)) {
                const business_mapping = this.state.featureAccess["business_mapping"];
                hidebusinessMappingTab = business_mapping === true;
        }


        let hideConfPagePipelineSourceTab = false;
        if (!IS_NONE_CHECK.includes(this.state.featureAccess)){
            const confPagePipelineData = this.state.featureAccess["pipeline"];
            if(confPagePipelineData!==undefined){
                hideConfPagePipelineSourceTab = confPagePipelineData === true;
            }
        }

        return (
            // this.state.errorOccurred ?
            //     <ErrorHandler/>
            // :
            <>
            {this.state.errorOccurred ? <ErrorHandler/> : ""}
            <div id="toastMsg">
            <Toast className={this.state.toastClass}
                   onClose={() =>  this.closeToast()}
                   show={this.state.toastStatus}
                   delay={3000} autohide>
                <div className="d-flex align-items-center">
                    <i className="toast-icon">
                         { this.state.toastIcon ?
                                <FontAwesomeIcon icon={ this.state.toastIcon }/> :
                                ""
                         }
                    </i>
                    <Toast.Body>
                        <strong className="toast-title">{this.state.toastHeading}</strong>
                        { this.state.toastBulk === "bulk" ?
                             this.state.toastMsg.map(function (row) {
                                        return <p>{row.message}</p>;
                             }) : <p>{ this.state.toastMsg }</p>
                        }
                    </Toast.Body>
                    <button type="button" onClick = {this.closeToast} className="close" data-dismiss="toast" aria-label="Close"/>
                </div>
            </Toast>
            </div>
                <NavigationHeader  page="configure" />
                <main>
                    <BreadCrumb icon='cog' title='Configure' />
                    <Tab.Container defaultActiveKey={this.state.current_tab} onSelect={this.handleTab}>
                        <div className="qd-tab__header">
                            <div className="container-fluid">
                                <div className="qd-tab__header-wrapper">
                                    <div className="qd-tab__header-menu">
                                        <Nav variant="tabs">
                                            <Nav.Item>
                                                <Nav.Link eventKey="ds" >
                                                    <span className="qd-menu__link-text">Datasources</span>
                                                </Nav.Link>
                                            </Nav.Item>
                                            {hideConfPageModelTab ?
                                                '' :
                                                <Nav.Item>
                                                    <Nav.Link eventKey="ml">
                                                        <span className="qd-menu__link-text">Models</span>
                                                    </Nav.Link>
                                                </Nav.Item>
                                            }
                                             {hideConfPagePipelineSourceTab ?
                                            <Nav.Item>
                                                <Nav.Link eventKey="pipeline" >
                                                    <span className="qd-menu__link-text">Pipelines & DAGS</span>
                                                </Nav.Link>
                                            </Nav.Item>
                                                : ''
                                            }
                                            {hidebusinessMappingTab ?
                                            <Nav.Item>
                                                <Nav.Link eventKey="business" >
                                                    <span className="qd-menu__link-text">Business</span>
                                                </Nav.Link> 
                                            </Nav.Item>  : '' }
                                        </Nav>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="qd-container">
                            <div className="qd-body">
                                <div className="qd-tab__content">
                                    <Tab.Content>
                                        <Tab.Pane eventKey="ds">
                                        <nav aria-label="breadcrumb" className="id__nav-breadcrumb breadcrumb-direct-section">
                                        <ol className="breadcrumb bg-transparent">
                                            <li className="breadcrumb-item"><a href="#jump-to_datasource">Add Datasources</a></li>
                                            <li className="breadcrumb-item"><a href="#jump-to_configure-datasource">Edit Datasource</a></li>

                                                        {
                                                            <li className="breadcrumb-item"><a href="#jump-to_datarefresh-interval">Data Refresh Interval</a></li>
                                                        }

                                                        <li className="breadcrumb-item"><a href="#jump-to_processerror">Processing Errors &amp; Data Refresh Status</a></li>
                                                    </ol>
                                                </nav>
                                                <>
                                                    <div id="jump-to_datasource" className="mb-15">
                                                        <BasicPortlet
                                                            className="pb-0" title="Datasources"
                                                            id="datasourceIndex"
                                                            content={
                                                                <DSEnvironment
                                                                    environment={this.state.environment}
                                                                    updateEnvironmentList={this.updateEnvironmentList}
                                                                    setDataLimit={this.setDataLimit}
                                                                    setEnvData={this.setEnvData}
                                                                    planName={this.state.planName}
                                                                    showToast={this.showToast}
                                                                    router={this.props.router}
                                                                    setPage={this.setAddDS}
                                                                    dataLimitExceed={this.state.dataLimitExceed} />
                                                            }
                                                        />
                                                    </div>
                                                    
                                                </>
                                                {

                                                    this.state.isAddDS ?
                                                        <AddDataSources
                                                            props={this.props}
                                                            showToast={this.showToast}
                                                            showCancel={true}
                                                            setPage={this.setAddDS}
                                                            setEnvData={this.setEnvData}
                                                            env_id={this.state.env_id}
                                                            isAddDS={this.state.isAddDS}
                                                            existingIntegrations={this.state.integration_details}
                                                            existingDatasources={this.state.allDataSourcesList} />
                                                        : ''
                                            }
                                           
                                                {this.renderTablesDatasources(this.state.current_tab)}
                                                {this.renderTableds(this.state.current_tab)}
                                                {
                                                    // IS_NONE_SAAS_EDITION ?
                                                        //Commented on new flow  this.renderScanIntervalComponents() 
                                                         <DataRefreshIntervalPortlet />
                                                        // : ''
                                                }

                                            <ConfigureDataRefreshTable
                                                dataRefreshes={this.state.dataRefreshesInfo}
                                                integrations={this.state.integration_details}
                                                datasources={this.state.allDataSourcesList}
                                                isLoading={this.state.dataRefreshesInfoLoading}
                                            />


                                        </Tab.Pane>
                                        {hideConfPageModelTab ?
                                                    '' :
                                        <Tab.Pane eventKey="ml">
                                        <nav aria-label="breadcrumb" className="id__nav-breadcrumb breadcrumb-direct-section">
                                        <ol className="breadcrumb bg-transparent">
                                        <li className="breadcrumb-item"><a href="#jump-to_models">Add Model</a></li>
                                        <li className="breadcrumb-item"><a href="#jump-to_configuredModels">Edit Model</a></li>
                                        <li className="breadcrumb-item"><a href="#jump-to_configured-model-ab-testing">Add a Version</a></li>
                                        <li className="breadcrumb-item"><a href="#jump-to_configured-model-ab-testing">Add AB Testing</a></li>
                                        <li className="breadcrumb-item"><a href="#jump-to_model-processing-errors">Processing Errors &amp; Refresh Status</a></li>
                                        </ol>
                                        </nav>
                                            <div id="jump-to_models" className="mb-15">
                                            <BasicPortlet
                                                className="pb-0" title="Models" id="modelIndex"
                                                content={
                                                    <MLModelEnvironment
                                                        maxModel={this.state.maxModel}
                                                        planName={this.state.planName}
                                                        updateEnvironmentList={this.updateEnvironmentList}
                                                        environment={this.state.environment}
                                                        showToast={this.showToast}
                                                        router={this.props.router}
                                                        setPage={this.setAddModel}
                                                        setModelVersion={this.setModelVersion}
                                                        change_request_exists={this.state.change_request_exists}
                                                        mlLimitExceed={this.state.mlLimitExceed}/>
                                                }
                                            />

                                                </div>
                                                {
                                                    this.state.isAddModel ?
                                                        <BasicPortlet
                                                            className="pb-3" title="Add Model" id="addModel" bodyClassName="pb-0"
                                                            content={<AddModel showToast={this.showToast}
                                                                integrationOption={this.state.integration_option}
                                                                setPage={this.setAddModel}
                                                                prefetch={this.props}
                                                                datasets={this.state.datasets}
                                                                attributes={this.state.attributes} />
                                                            }
                                                        /> : ''
                                                }

                                            {
                                                this.state.isModelVersion ?
                                                    <BasicPortlet
                                                        className="pb-3"
                                                        title="Create another version of the existing model"
                                                        id="createModelVersion"
                                                        bodyClassName="pb-0"
                                                        content={<AddModel showToast={this.showToast}
                                                                           integrationOption={this.state.integration_option}
                                                                           setPage={this.setModelVersion}
                                                                           prefetch={this.props}
                                                                           datasets={this.state.datasets}
                                                                           attributes={this.state.attributes}/>
                                                        }
                                                    /> : ''
                                            }

                                                {this.renderTableml(this.state.current_tab)}

                                                {this.renderModelABTable(this.state.current_tab)}

                                            {this.renderRefreshTable(this.state.model_updates,'ml')}
                                        </Tab.Pane>

                                        }
                                        {hideConfPagePipelineSourceTab?
                                        <Tab.Pane eventKey="pipeline">
                                        <nav aria-label="breadcrumb" className="id__nav-breadcrumb breadcrumb-direct-section">
                                        <ol className="breadcrumb bg-transparent">
                                            <li className="breadcrumb-item"><a href="#jump-to_pipeline">Add Pipeline</a></li>
                                            <li className="breadcrumb-item"><a href="#jump-to_configure-pipeline">Edit Pipeline</a></li>
                                            <li className="breadcrumb-item"><a href="#jump-to_pipelineprocesserror">Processing Errors &amp; Pipeline Status</a></li>
                                        </ol>
                                        </nav>
                                        <>
                                          <div id="jump-to_pipeline" className="mb-15">
                                            <BasicPortlet
                                                className="pb-0" title="Pipelines & DAGS"
                                                id="datasourceIndex"
                                                content={
                                                    <PipelineEnvironment
                                                                   environment={this.state.environment}
                                                                   updateEnvironmentList={this.updateEnvironmentList}
                                                                   setDataLimit={this.setDataLimit}
                                                                   setEnvData={this.setEnvData}
                                                                   planName={this.state.planName}
                                                                   showToast={this.showToast}
                                                                   router={this.props.router}
                                                                   setPage={this.setAddDS}
                                                                   dataLimitExceed={this.state.dataLimitExceed}/>
                                                }
                                            />
                                            </div>
                                            </>
                                            {
                                                this.state.isAddDS ?
                                                    <AddPipeline
                                                                    props={this.props}
                                                                    showToast={this.showToast}
                                                                    showCancel={true}
                                                                    setPage={this.setAddDS}
                                                                    setEnvData={this.setEnvData}
                                                                    env_id={this.state.env_id}
                                                                    existingIntegrations={this.state.integration_details}/>
                                                     : ''
                                            }
                                            {this.renderTablepipeline(this.state.current_tab)}
                                            {this.renderRefreshTable(this.state.pipelinesource_updates,this.state.current_tab)}
                                            {/* {this.renderRefreshTable(this.state.pipelinesource_updates,this.state.current_tab)} */}
                                        </Tab.Pane>
                                        :''
                                        }
                                        <Tab.Pane eventKey="business">
                                            <nav aria-label="breadcrumb" className="id__nav-breadcrumb breadcrumb-direct-section">
                                                <ol className="breadcrumb bg-transparent">
                                                    <li className="breadcrumb-item">
                                                        <a 
                                                            href="#jump-to_kpiCatalog" 
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                this.setState({ business_sub_tab: 'kpiCatalog' });
                                                                if (!this.state.businessCatalogueState) {
                                                                    this.loadBusinessCatalogue();
                                                                }
                                                            }}
                                                            className={this.state.business_sub_tab === 'kpiCatalog' 
                                                                ? "!tw-text-[#0056b3] dark:!tw-text-blue-400 tw-border-0 !tw-border-b-2 !tw-border-solid !tw-border-[#0056b3] dark:!tw-border-blue-400 tw-pb-[3px] tw-font-medium" 
                                                                : "tw-text-[#525252] dark:tw-text-[#A4A7AE] tw-border-0 !tw-border-b-2 !tw-border-solid !tw-border-transparent hover:!tw-border-[#0056b3] dark:hover:!tw-border-blue-400 tw-pb-[3px] hover:!tw-text-[#0056b3] dark:hover:!tw-text-blue-400 tw-transition-colors"
                                                            }
                                                        >
                                                            KPI Catalog 
                                                        </a>
                                                    </li>
                                                    <li className="breadcrumb-item">
                                                        <a 
                                                            href="#jump-to_domainMapping" 
                                                            onClick={(e) => {
                                                                e.preventDefault();
                                                                this.setState({
                                                                    business_sub_tab: 'domainMapping',
                                                                    businessMappingsLoading: false
                                                                });
                                                            }}
                                                            className={this.state.business_sub_tab === 'domainMapping' 
                                                                ? "!tw-text-[#0056b3] dark:!tw-text-blue-400 tw-border-0 !tw-border-b-2 !tw-border-solid !tw-border-[#0056b3] dark:!tw-border-blue-400 tw-pb-[3px] tw-font-medium" 
                                                                : "tw-text-[#525252] dark:tw-text-[#A4A7AE] tw-border-0 !tw-border-b-2 !tw-border-solid !tw-border-transparent hover:!tw-border-[#0056b3] dark:hover:!tw-border-blue-400 tw-pb-[3px] hover:!tw-text-[#0056b3] dark:hover:!tw-text-blue-400 tw-transition-colors"
                                                            }
                                                        >
                                                            Data Assets Mapping
                                                        </a>
                                                    </li>
                                                    {/* <li className="breadcrumb-item">
                                                        <a 
                                                            href="#jump-to_modelsMapping" 
                                                            onClick={(e) => { e.preventDefault(); this.setState({ business_sub_tab: 'modelsMapping' }); }}
                                                            className={this.state.business_sub_tab === 'modelsMapping' 
                                                                ? "!tw-text-[#0056b3] dark:!tw-text-blue-400 tw-border-0 !tw-border-b-2 !tw-border-solid !tw-border-[#0056b3] dark:!tw-border-blue-400 tw-pb-[3px] tw-font-medium" 
                                                                : "tw-text-[#525252] dark:tw-text-[#A4A7AE] tw-border-0 !tw-border-b-2 !tw-border-solid !tw-border-transparent hover:!tw-border-[#0056b3] dark:hover:!tw-border-blue-400 tw-pb-[3px] hover:!tw-text-[#0056b3] dark:hover:!tw-text-blue-400 tw-transition-colors"
                                                            }
                                                        >
                                                            Models Mapping
                                                        </a>
                                                    </li> */}
                                                </ol>
                                            </nav>
                                            {this.state.businessCatalogueLoading && this.state.business_sub_tab === 'kpiCatalog' ? (
                                                <BasicPortlet
                                                    className="pb-0"
                                                    id="businessCatalogueLoading"
                                                    title="Business Library"
                                                    content={<Load />}
                                                />
                                            ) : (
                                                <>
                                                    {this.state.business_sub_tab === 'kpiCatalog' && (
                                                        <div id="jump-to_kpiCatalog" className="mb-15">
                                                            <KpiCatalogView
                                                                skipInitialFetch
                                                                initialCatalogueState={this.state.businessCatalogueState}
                                                                showToast={this.showToast}
                                                            />
                                                        </div>
                                                    )}
                                                    {this.state.business_sub_tab === 'domainMapping' && (
                                                        <div id="jump-to_domainMapping" className="mb-15">
                                                            <DomainMappingView
                                                                showToast={this.showToast}
                                                                environment={this.state.environment}
                                                            />
                                                        </div>
                                                    )}
                                                    {this.state.business_sub_tab === 'modelsMapping' && (
                                                        <div id="jump-to_modelsMapping" className="mb-15">
                                                            <div className="tw-bg-white dark:tw-bg-[#1E1E2D] tw-border tw-border-solid tw-border-[#ECECEC] dark:tw-border-white/10 tw-rounded-2xl tw-p-8 tw-text-center tw-my-4">
                                                                <div className="tw-w-12 tw-h-12 tw-mx-auto tw-rounded-xl tw-bg-indigo-50 dark:tw-bg-indigo-950/30 tw-flex tw-items-center tw-justify-center tw-mb-3">
                                                                    <svg className="tw-w-6 tw-h-6 tw-text-indigo-400" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="3"/><circle cx="5" cy="6" r="2"/><circle cx="19" cy="6" r="2"/><path d="M7 6h3a2 2 0 0 1 2 2v1M17 6h-3M12 12v0"/></svg>
                                                                </div>
                                                                <h4 className="tw-text-sm tw-font-semibold tw-text-gray-900 dark:tw-text-white tw-mb-2">Models Mapping</h4>
                                                                <p className="tw-text-xs tw-text-gray-500 dark:tw-text-gray-400 tw-mb-0">Bind KPIs and Functions to ML models that score, forecast or anomaly-detect them. Placeholder — out of scope for this prototype.</p>
                                                            </div>
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="widget">
                                            <URLWidget title="Dashboard"/>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="api">
                                            <URLWidget title="API"/>
                                        </Tab.Pane>
                                    </Tab.Content>
                                </div>
                                <div className='d-none tw-fixed tw-bottom-0 tw-z-[999] tw-w-[94%] tw-left-[50%] tw-ms-[-47%] sm:tw-w-[400px] sm:tw-left-auto sm:tw-right-[40px]'>
                                    <div className='tw-rounded-t-2xl tw-bg-white dark:tw-bg-[#1E1E2D] tw-shadow-[0px_0px_3px_-1.5px_#0A0D1214,0px_0px_8px_-4px_#0A0D120F,0px_0px_24px_-4px_#0A0D1229] dark:tw-shadow-[0px_0px_3px_-1.5px_#ffffff14,0px_0px_8px_-4px_#ffffff0f,0px_0px_24px_-4px_#ffffff29]'>
                                        <div>
                                            {/* Add this class tw-bg-white dark:tw-bg-[#1E1E2D] 
                                                Add for Success -  tw-bg-[#ECFDF3]
                                                Add for Incomplete -  tw-bg-[#FFFCF5] 
                                            */}
                                            <div className='tw-bg-white dark:tw-bg-[#1E1E2D] tw-rounded-t-2xl tw-flex tw-items-center tw-justify-between'>
                                                <div className='tw-px-4 sm:tw-px-6 tw-py-3'>
                                                    {/* Remove this class tw-text-[#181D27] dark:tw-text-[#B2B5BE] 
                                                        Add for Success -  tw-text-[#079455]
                                                        Add for Incomplete -  tw-text-[#DC6803] 
                                                    */}
                                                    <h2 className='tw-text-base sm:tw-text-[18px] tw-font-semibold tw-text-[#181D27] dark:tw-text-[#B2B5BE] tw-mb-1'>Configuration In Progress</h2>
                                                    <div className='tw-flex tw-items-center tw-gap-1'>
                                                        <i>
                                                            <svg className='tw-block' width="14" height="14" viewBox="0 0 147 140" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <g clip-path="url(#clip0_1563_1485)">
                                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M134.806 60.0962L118.336 69.5862L134.806 78.9962C135.791 79.5655 136.654 80.3232 137.346 81.226C138.038 82.1289 138.546 83.1592 138.84 84.2582C139.134 85.3572 139.208 86.5033 139.059 87.6311C138.91 88.7589 138.541 89.8463 137.971 90.8312C137.402 91.8161 136.644 92.6793 135.741 93.3713C134.839 94.0634 133.808 94.5709 132.709 94.8648C131.61 95.1587 130.464 95.2333 129.336 95.0842C128.209 94.9352 127.121 94.5655 126.136 93.9962L96.6262 76.9962C95.2737 76.2137 94.1576 75.0807 93.3955 73.7166C92.6334 72.3526 92.2536 70.8081 92.2962 69.2462C92.3193 68.5695 92.4234 67.8981 92.6062 67.2462C93.2103 65.06 94.646 63.1972 96.6062 62.0562L126.116 45.1162C127.105 44.5445 128.198 44.1736 129.33 44.0245C130.463 43.8755 131.614 43.9513 132.718 44.2476C133.821 44.5439 134.855 45.0548 135.761 45.7513C136.667 46.4477 137.426 47.3159 137.996 48.3062C138.568 49.2879 138.94 50.3734 139.089 51.4999C139.239 52.6263 139.163 53.7712 138.866 54.868C138.569 55.9649 138.057 56.9919 137.361 57.8894C136.664 58.7869 135.795 59.537 134.806 60.0962ZM119.216 106.096L89.7162 89.1262C88.3964 88.3687 86.9013 87.9699 85.3796 87.9692C83.8579 87.9686 82.3625 88.3661 81.042 89.1224C79.7215 89.8787 78.6219 90.9674 77.8525 92.2803C77.0831 93.5932 76.6707 95.0845 76.6562 96.6062V130.506C76.7327 132.759 77.6812 134.893 79.3016 136.46C80.922 138.026 83.0875 138.901 85.3412 138.901C87.5949 138.901 89.7605 138.026 91.3809 136.46C93.0013 134.893 93.9498 132.759 94.0262 130.506V111.506L110.536 120.996C111.521 121.566 112.609 121.936 113.737 122.086C114.865 122.236 116.011 122.162 117.111 121.868C118.21 121.575 119.241 121.068 120.144 120.376C121.048 119.684 121.806 118.821 122.376 117.836C122.946 116.851 123.317 115.764 123.466 114.636C123.616 113.508 123.542 112.361 123.248 111.262C122.955 110.162 122.448 109.131 121.756 108.228C121.064 107.324 120.201 106.566 119.216 105.996V106.096ZM85.2162 72.9362L72.9162 85.0862C72.4954 85.4774 71.9501 85.7076 71.3762 85.7362H67.7662C67.1937 85.7018 66.6502 85.4724 66.2262 85.0862L53.9962 72.8962C53.6136 72.4787 53.3875 71.9416 53.3562 71.3762V67.7762C53.3892 67.2082 53.615 66.6685 53.9962 66.2462L66.2262 54.0562C66.6512 53.6729 67.1948 53.447 67.7662 53.4162H71.3762C71.9486 53.4429 72.4935 53.6693 72.9162 54.0562L85.1762 66.2462C85.5545 66.6695 85.7767 67.2093 85.8062 67.7762V71.3762C85.7785 71.9405 85.5559 72.4778 85.1762 72.8962L85.2162 72.9362ZM75.4162 69.5562C75.369 68.9732 75.1258 68.4234 74.7262 67.9962L71.1762 64.4862C70.7508 64.1036 70.2075 63.8778 69.6362 63.8462H69.5062C68.9375 63.876 68.3968 64.1022 67.9762 64.4862L64.4262 67.9962C64.0451 68.4256 63.8228 68.9727 63.7962 69.5462V69.6762C63.8214 70.2411 64.0444 70.7791 64.4262 71.1962L67.9962 74.6962C68.4177 75.0788 68.9579 75.3048 69.5262 75.3362H69.6562C70.2275 75.3046 70.7708 75.0788 71.1962 74.6962L74.7462 71.1662C75.1297 70.7483 75.359 70.2121 75.3962 69.6462L75.4162 69.5562ZM19.9262 33.0762L49.4362 49.9962C50.7575 50.7533 52.2539 51.1517 53.7768 51.1516C55.2996 51.1516 56.796 50.7532 58.1173 49.9961C59.4386 49.2389 60.5388 48.1492 61.3087 46.8353C62.0786 45.5214 62.4915 44.029 62.5062 42.5062V8.63619C62.4298 6.38379 61.4813 4.24919 59.8609 2.68284C58.2405 1.1165 56.0749 0.240938 53.8212 0.240938C51.5675 0.240938 49.402 1.1165 47.7816 2.68284C46.1612 4.24919 45.2127 6.38379 45.1362 8.63619V27.6362L28.6062 18.1362C27.6213 17.5663 26.5338 17.1959 25.4057 17.0462C24.2777 16.8966 23.1312 16.9706 22.0318 17.264C20.9323 17.5575 19.9014 18.0646 18.998 18.7564C18.0945 19.4483 17.3361 20.3113 16.7662 21.2962C16.1963 22.2811 15.8259 23.3686 15.6763 24.4967C15.5266 25.6247 15.6006 26.7712 15.8941 27.8706C16.1875 28.9701 16.6946 30.001 17.3864 30.9044C18.0783 31.8079 18.9413 32.5663 19.9262 33.1362V33.0762ZM84.6862 51.1562C86.4288 51.294 88.1722 50.9 89.6862 50.0262L119.186 33.0262C120.171 32.4563 121.034 31.6979 121.726 30.7944C122.418 29.891 122.925 28.8601 123.218 27.7606C123.512 26.6612 123.586 25.5147 123.436 24.3867C123.287 23.2586 122.916 22.1711 122.346 21.1862C121.776 20.2013 121.018 19.3383 120.114 18.6464C119.211 17.9546 118.18 17.4475 117.081 17.154C114.86 16.5614 112.495 16.8752 110.506 18.0262L93.9962 27.6062V8.60619C93.9198 6.35379 92.9713 4.21919 91.3509 2.65284C89.7305 1.0865 87.5649 0.210938 85.3112 0.210938C83.0575 0.210938 80.892 1.0865 79.2716 2.65284C77.6512 4.21919 76.7026 6.35379 76.6262 8.60619V42.5062C76.6235 44.701 77.4542 46.8149 78.9504 48.4207C80.4466 50.0264 82.4967 51.0041 84.6862 51.1562ZM54.4762 87.9962C52.7333 87.8546 50.9888 88.2488 49.4762 89.1262L19.9262 106.056C17.9371 107.207 16.4867 109.101 15.8941 111.322C15.3015 113.542 15.6152 115.907 16.7662 117.896C17.9173 119.885 19.8113 121.336 22.0318 121.928C24.2522 122.521 26.6171 122.207 28.6062 121.056L45.1362 111.566V130.566C45.2127 132.819 46.1612 134.953 47.7816 136.52C49.402 138.086 51.5675 138.961 53.8212 138.961C56.0749 138.961 58.2405 138.086 59.8609 136.52C61.4813 134.953 62.4298 132.819 62.5062 130.566V96.6062C62.5017 94.4225 61.6715 92.3212 60.1821 90.7243C58.6926 89.1273 56.6543 88.1527 54.4762 87.9962ZM46.4762 72.1262C47.0459 70.2529 46.96 68.2415 46.2328 66.4235C45.5057 64.6056 44.1806 63.0898 42.4762 62.1262L12.9962 45.1362C11.0053 43.9958 8.64409 43.6891 6.42786 44.283C4.21163 44.8768 2.32019 46.3231 1.16621 48.3062C0.594906 49.2876 0.223871 50.3726 0.0745668 51.4983C-0.074737 52.6241 0.000654668 53.7682 0.296381 54.8647C0.592107 55.9611 1.1023 56.988 1.79744 57.886C2.49258 58.7839 3.35887 59.5352 4.34621 60.0962L20.8162 69.5862L4.34621 78.9962C3.3613 79.5642 2.4979 80.3206 1.80531 81.2222C1.11272 82.1238 0.604499 83.1531 0.309673 84.2511C0.0148467 85.3492 -0.0608148 86.4946 0.0870081 87.6218C0.234831 88.7491 0.603243 89.8363 1.17121 90.8212C1.73918 91.8061 2.49558 92.6695 3.39722 93.3621C4.29886 94.0547 5.32809 94.5629 6.42615 94.8577C7.5242 95.1526 8.66957 95.2282 9.79686 95.0804C10.9242 94.9326 12.0113 94.5642 12.9962 93.9962L42.4762 76.9962C44.3746 75.9363 45.8005 74.196 46.4662 72.1262H46.4762ZM139.626 15.9062H138.296V17.5362H139.616C140.226 17.5362 140.616 17.2562 140.616 16.7362C140.616 16.2162 140.256 15.9062 139.616 15.9062H139.626ZM136.686 14.4062H139.686C141.306 14.4062 142.386 15.2962 142.386 16.6762C142.391 17.0603 142.294 17.4389 142.104 17.7729C141.914 18.1068 141.639 18.3841 141.306 18.5762L142.476 20.2562V20.5962H140.786L139.616 18.9962H138.296V20.5962H136.676L136.686 14.4062ZM144.986 17.6262C145.035 16.8692 144.926 16.1103 144.666 15.3976C144.406 14.6849 144.001 14.034 143.476 13.4859C142.952 12.9379 142.319 12.5047 141.619 12.2139C140.918 11.923 140.165 11.7808 139.406 11.7962C136.096 11.7962 133.896 14.1862 133.896 17.6262C133.896 20.9062 136.096 23.4462 139.406 23.4462C140.165 23.4644 140.919 23.3245 141.621 23.0354C142.323 22.7463 142.957 22.3143 143.483 21.7669C144.008 21.2195 144.414 20.5687 144.675 19.8558C144.936 19.1429 145.045 18.3836 144.996 17.6262H144.986ZM146.366 17.6262C146.366 21.5162 143.766 24.7662 139.366 24.7662C134.966 24.7662 132.476 21.4862 132.476 17.6262C132.476 13.7662 135.046 10.4862 139.366 10.4862C143.686 10.4862 146.356 13.7262 146.356 17.6262H146.366Z" fill="#29B5E8"/>
                                                                </g>
                                                                <defs>
                                                                <clipPath id="clip0_1563_1485">
                                                                <rect width="146.36" height="139.16" fill="white"/>
                                                                </clipPath>
                                                                </defs>
                                                            </svg>
                                                        </i>
                                                        <span className='tw-w-1 tw-h-1 tw-rounded-full tw-bg-[#535862]'></span>
                                                        <span className='tw-text-xs sm:tw-text-sm tw-text-[#535862] dark:tw-text-[#787B86] tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis'>Demo Snowflake - PROD_DB</span>
                                                    </div>
                                                </div>
                                                <div className="tw-flex tw-items-center tw-p-1">
                                                    <button className='tw-p-[6px] sm:tw-p-[10px] tw-rounded-lg  tw-flex tw-items-center tw-justify-center tw-bg-transparent tw-border-0 hover:tw-bg-[#F4F5F5] dark:hover:tw-bg-[#2B2B40]' onClick={this.handleConfigureProgressCollapse}>
                                                        <ChevronDown size={24} color="#A4A7AE" />
                                                    </button>
                                                    <button className='tw-p-[6px] sm:tw-p-[10px] tw-rounded-lg  tw-flex tw-items-center tw-justify-center tw-bg-transparent tw-border-0 hover:tw-bg-[#F4F5F5] dark:hover:tw-bg-[#2B2B40]'>
                                                        <X size={24} color="#A4A7AE" />
                                                    </button>
                                                </div>
                                            </div>
                                            {/* Remove this class tw-bg-[#F5F5F5 
                                                Add for Success -  tw-bg-[#ECFDF3]
                                                Add for Incomplete -  tw-bg-[#FFFCF5] 
                                            */}
                                            <div class="tw-flex tw-items-center tw-gap-3 tw-py-4 tw-px-4 sm:tw-px-6 tw-bg-[#F5F5F5] dark:tw-bg-[#252535]">
                                                <div class="tw-flex-1 tw-h-2 tw-rounded-full tw-bg-[#E9EAEB]">
                                                    {/* Add this class tw-bg-[#0021A5 
                                                        Add for Success -  tw-bg-[#17B26A]
                                                        Add for Incomplete -  tw-bg-[#D92D20] 
                                                    */}
                                                    <div class="tw-h-2 tw-rounded-full tw-bg-[#0021A5] tw-w-[70%]"></div>
                                                </div>
                                                <span class="tw-text-sm tw-font-medium tw-text-[#414651] dark:tw-text-[#B2B5BE]">70%</span>
                                            </div>
                                        </div>
                                        <div className={`integration-collapse-content ${this.state.configureProgressCollpase? "open tw-p-4 sm:tw-p-6" : ""}`}>
                                            <div className='tw-flex tw-flex-col tw-gap-3'>
                                                <div className='tw-py-3 tw-px-4 tw-flex tw-items-center tw-gap-3 tw-border tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40] tw-rounded-xl'>
                                                    <i>
                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="#079455" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                        </svg>
                                                    </i>
                                                    <div>
                                                        <h6 className='tw-text-sm tw-font-medium tw-text-[#079455] tw-m-0'>Validating Configuration</h6>
                                                        <p className='tw-text-xs tw-text-[#535862] dark:tw-text-[#787B86] tw-m-0'>Validating Configuration</p>
                                                    </div>
                                                </div>
                                                <div className='tw-py-3 tw-px-4 tw-flex tw-items-center tw-gap-3 tw-border tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40] tw-rounded-xl'>
                                                    <i>
                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="#079455" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                        </svg>
                                                    </i>
                                                    <div>
                                                        <h6 className='tw-text-sm tw-font-medium tw-text-[#079455] tw-m-0'>Saving Configuration</h6>
                                                        <p className='tw-text-xs tw-text-[#535862] dark:tw-text-[#787B86] tw-m-0'>Storing datasource settings securely</p>
                                                    </div>
                                                </div>
                                                <div className='tw-py-3 tw-px-4 tw-flex tw-items-center tw-gap-3 tw-border tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40] tw-rounded-xl'>
                                                    <i>
                                                        <div className="tw-w-[24px] tw-h-[24px] tw-border-2 tw-border-solid tw-rounded-full tw-border-[#D1E9FF] tw-border-t-[#0021A5] tw-animate-spin"></div>
                                                    </i>
                                                    <div>
                                                        <h6 className='tw-text-sm tw-font-medium tw-text-[#0021A5] tw-m-0'>Registering in Quality Data</h6>
                                                        <p className='tw-text-xs tw-text-[#535862] dark:tw-text-[#787B86] tw-m-0'>Adding to data catalog and enabling monitoring</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='tw-hidden tw-flex-col tw-gap-3'>{/* Add this class tw-flex and remove tw-hidden */}
                                                <div className='tw-flex tw-items-center tw-gap-4'>
                                                    <i className='tw-p-[14px] tw-rounded-full tw-bg-[#DCFAE6]'>
                                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="#079455" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                                        </svg>
                                                    </i>
                                                    <div>
                                                        <h6 className='tw-text-base tw-font-semibold tw-text-[#079455] tw-mt-0 tw-mb-[2px]'>Configuration Successful!</h6>
                                                        <p className='tw-text-sm tw-text-[#535862] dark:tw-text-[#787B86] tw-m-0'>Your datasource has been successfully configured and is now available in the Quality Data app for data integration and quality checks.</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='tw-hidden tw-flex-col tw-gap-3'>{/* Add this class tw-flex and remove tw-hidden */}
                                                <div className='tw-flex tw-items-center tw-gap-4'>
                                                    <i className='tw-p-[14px] tw-rounded-full tw-bg-[#FFFAEB]'>
                                                        <TriangleAlert size={24} color="#DC6803" />
                                                    </i>
                                                    <div>
                                                        <h6 className='tw-text-base tw-font-semibold tw-text-[#DC6803] tw-mt-0 tw-mb-[2px]'>Configuration Incomplete</h6>
                                                        <p className='tw-text-sm tw-text-[#535862] dark:tw-text-[#787B86] tw-m-0'>Your datasource has been successfully configured and is now available in the Quality Data app for data integration and quality checks.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {/* Test Connection Popup */}

                           
                                

                                {this.state.testConnectionDataSource && (
                                <div className='tw-fixed tw-bottom-0 tw-z-[999] tw-w-[94%] tw-left-[50%] tw-ms-[-47%] sm:tw-w-[400px] sm:tw-left-auto sm:tw-right-[40px]'>
                                    <div className='tw-rounded-t-2xl tw-bg-white dark:tw-bg-[#1E1E2D] tw-shadow-[0px_0px_3px_-1.5px_#0A0D1214,0px_0px_8px_-4px_#0A0D120F,0px_0px_24px_-4px_#0A0D1229] dark:tw-shadow-[0px_0px_3px_-1.5px_#ffffff14,0px_0px_8px_-4px_#ffffff0f,0px_0px_24px_-4px_#ffffff29]'>
                                        <div className='tw-border-0 tw-border-b tw-border-solid tw-border-[#C7D7FE] dark:tw-border-[#2B2B40]'>
                                            <div className='tw-bg-white dark:tw-bg-[#1E1E2D] tw-rounded-t-2xl tw-flex tw-items-center tw-justify-between'>
                                                <div className='tw-px-4 sm:tw-px-6 tw-py-3'>
                                                    <h2 className='tw-text-base sm:tw-text-[18px] tw-font-semibold tw-text-[#181D27] dark:tw-text-[#B2B5BE] tw-mb-1'>Test Connection</h2>
                                                    <div className='tw-flex tw-items-center tw-gap-1'>
                                                        {getDatasourceIcon(this.state.testConnectionType)} 
                                                        {console.log("index.js")}
                                                        <span className='tw-text-xs sm:tw-text-sm tw-text-[#535862] dark:tw-text-[#787B86] tw-whitespace-nowrap tw-overflow-hidden tw-text-ellipsis'>{this.state.testConnectionDatasourceName} - {this.state.testConnectionEnvName}</span>
                                                    </div>
                                                </div>
                                                <div className="tw-flex tw-items-center tw-p-1">
                                                    <button type="button" onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.testConnectionDataSourceClose(); }} className='tw-p-[6px] sm:tw-p-[10px] tw-rounded-lg  tw-flex tw-items-center tw-justify-center tw-bg-transparent tw-border-0 hover:tw-bg-[#F4F5F5] dark:hover:tw-bg-[#2B2B40]'>
                                                        <X size={24} color="#A4A7AE" />
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className={`integration-collapse-content tw-bg-[#EEF4FF]/50 dark:tw-bg-white/[0.03] ${this.state.configureProgressCollpase? "open" : ""}`}>
                                            <div className='tw-px-6'>
                                                <div className='tw-py-3 tw-border-0 tw-border-b tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40]'>
                                                    <div className="tw-flex tw-items-center tw-gap-4" >
                                                        <i >
                                                            <svg className='tw-text-[#3538CD] dark:tw-text-[#53B1FD]' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M17 19C16.7348 19 16.4804 18.8946 16.2929 18.7071C16.1054 18.5196 16 18.2652 16 18V16C16 15.4696 16.2107 14.9609 16.5858 14.5858C16.9609 14.2107 17.4696 14 18 14H20C20.5304 14 21.0391 14.2107 21.4142 14.5858C21.7893 14.9609 22 15.4696 22 16V18C22 18.2652 21.8946 18.5196 21.7071 18.7071C21.5196 18.8946 21.2652 19 21 19M17 19H21M17 19V21M21 19V21M19 14V6.5C19 5.57174 18.6313 4.6815 17.9749 4.02513C17.3185 3.36875 16.4283 3 15.5 3C14.5717 3 13.6815 3.36875 13.0251 4.02513C12.3687 4.6815 12 5.57174 12 6.5V17.5C12 18.4283 11.6313 19.3185 10.9749 19.9749C10.3185 20.6313 9.42826 21 8.5 21C7.57174 21 6.6815 20.6313 6.02513 19.9749C5.36875 19.3185 5 18.4283 5 17.5V10M3 5V3M3 5C2.73478 5 2.48043 5.10536 2.29289 5.29289C2.10536 5.48043 2 5.73478 2 6V8C2 8.53043 2.21071 9.03914 2.58579 9.41421C2.96086 9.78929 3.46957 10 4 10H6C6.53043 10 7.03914 9.78929 7.41421 9.41421C7.78929 9.03914 8 8.53043 8 8V6C8 5.73478 7.89464 5.48043 7.70711 5.29289C7.51957 5.10536 7.26522 5 7 5M3 5H7M7 5V3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                            </svg>
                                                        </i>
                                                        <div>
                                                            <h4 className='tw-mb-0 tw-text-sm lg:tw-text-base tw-font-semibold tw-text-[#3538CD] dark:tw-text-[#53B1FD]'>Test your connection</h4>{/* Replace this class "tw-text-[#3538CD]" to "tw-text-[#067647]" */}
                                                            <p className='m-0 tw-text-sm lg:tw-text-base tw-text-[#444CE7] dark:tw-text-[#787B86]'>Verify your credentials are correct</p>{/* Replace this class "tw-text-[#444CE7]" to "tw-text-[#535862] dark:tw-text-[#787B86]" */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='tw-flex tw-flex-col tw-gap-[6px] tw-pt-3 tw-pb-4 tw-px-4 sm:tw-px-6'>
                                                {this.state.testConnectionStages && this.state.testConnectionStages.length > 0 ? (
                                                    this.state.testConnectionStages.map((stage, index) => (
                                                        <div key={stage.stage} className='tw-py-[6px] tw-flex tw-items-center tw-gap-3'>
                                                            <i>
                                                                {stage.status === true ? (
                                                                    // Completed stage - green checkmark
                                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M7.5 12L10.5 15L16.5 9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="#079455" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                                    </svg>
                                                                ) : stage.status === false || stage.status === null  ? (
                                                                    // Failed stage - red cross
                                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                        <path d="M9 9L15 15M15 9L9 15M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="#D92D20" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                                    </svg>
                                                                ) : (
                                                                    // Pending stage - spinner
                                                                    <div className="tw-w-[24px] tw-h-[24px] tw-border-2 tw-border-solid tw-rounded-full tw-border-[#D1E9FF] dark:tw-border-white/10 tw-border-t-[#0021A5] dark:tw-border-t-[#53B1FD] tw-animate-spin"></div>
                                                                )}
                                                            </i>
                                                            <div>
                                                                <h6 className={`tw-text-sm tw-font-medium tw-m-0 ${
                                                                    stage.status === true ? 'tw-text-[#079455]' : 
                                                                    stage.status === false || stage.status === null ? 'tw-text-[#D92D20]' : 
                                                                    'tw-text-[#0021A5] dark:tw-text-[#53B1FD]'
                                                                }`}>
                                                                    {stage.name}
                                                                </h6>
                                                            </div>
                                                        </div>
                                                    ))
                                                ) : (
                                                    // Default placeholder if no stages
                                                    <>
                                                        <div className='tw-py-[6px] tw-flex tw-items-center tw-gap-3'>
                                                            <i>
                                                                <div className="tw-w-[24px] tw-h-[24px] tw-border-2 tw-border-solid tw-rounded-full tw-border-[#D1E9FF] dark:tw-border-white/10 tw-border-t-[#0021A5] dark:tw-border-t-[#53B1FD] tw-animate-spin"></div>
                                                            </i>
                                                            <div>
                                                                <h6 className='tw-text-sm tw-font-medium tw-text-[#0021A5] dark:tw-text-[#53B1FD] tw-m-0'>Verifying the test connection.</h6>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                            </div>
                                            <div className='tw-flex tw-align-center tw-justify-end tw-px-4 tw-py-4 sm:tw-px-6 tw-border-0 tw-border-t tw-border-solid tw-border-[#E9EAEB] dark:tw-border-[#2B2B40]'>
                                                <button type="button" className="btn btn-outline btn-grey" onClick={(e) => { e.preventDefault(); e.stopPropagation(); this.testConnectionDataSourceClose(); }}>Cancel</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>)}    
                            </div>
                        </div>
                    </Tab.Container>
                </main>
                <CopyRightsFooter/>
                </>
        );
    }
}

//export default Configure;

const mapStateToProps = state => {
    return state;
}

export default connect(
    mapStateToProps, {
    addMetaData,
    addMLModelMapping,
    setMLModel,
    setModelABDataToList,
    addEnvironment,
    addEnvironmentDataSourceMapping,
    addDataSourceDataSetMapping,
    addDataSetAttributeMapping,
    setDataSet,
    setAttribute,
    setDataSource,
    setMlDataSource,
    addRelationship,
    addDataSource,
    addInfo,
    addLastProfilingTime,
    setStartDate,
    setEndDate,
    addDiscoveryStatus,
    addProcessingStatus,
    addMonitorPreview,
    addPerformancePreview,
    addModelPerformance,
    addCompletenessDataSetInfo,
    addCompletenessAttributeInfo,
    addTimelinessDataSetInfo,
    addTimelinessAttributeInfo,
    addAccuracyDataSetInfo,
    addAccuracyAttributeInfo,
    addConformityDataSetInfo,
    addConformityAttributeInfo,
    addConsistencyDataSetInfo,
    addConsistencyAttributeInfo,
    addDriftDataSetInfo,
    addDriftAttributeInfo,
    addMLDataSetInfo,
    addMLAttributeInfo,
    addUniquenessDataSetInfo,
    addUniquenessAttributeInfo,
    addRecencyPreview,
    addMLModel,
    addModelDetails,
    addMetrics,
    addMonitorDQListViewData,
    prefetchMonitorState,
    noIntegration,
    mappedDatasetInfo,
    listViewTableData
}
)(Configure);
